export enum AdMarkErid {
	RKO = '2Ranynd1b2Z',
	RBO = '2RanynQ7EF2',
	FRANCHISE = '2RanykW832y',
}

export enum EridParam {
	RKO = '2RanynZ19w6',
	RBO = '2RanynW3BNQ',
	FRANCHISE = '2RanykuqqYV',
}
